import React from 'react'

const Header = () => {
  return (
    <div className='flex item-center justify-center mb-10 pt-1 pb-2 border-b'>
      <h1 className="text-5xl font-bold animate-pulse text-purple-400">Real Time Location Sharing Room Web-App</h1>
    </div>
  )
}

export default Header
